import React from "react";
import Bredcom from "./Utils/Bradcom";
import CustomizedSlider from "./Utils/CustomizedSlider";

import commonSpaces1 from "../assets/img/rooms/sala.jpg";
import commonSpaces2 from "../assets/img/rooms/sala-gier.jpg";
import commonSpaces3 from "../assets/img/rooms/sala-bar.jpg";
import commonSpaces4 from "../assets/img/rooms/sala-2.jpg";
import commonSpaces5 from "../assets/img/rooms/sala-gier-2.jpg";

import room1 from "../assets/img/rooms/room1.jpg";
import room2 from "../assets/img/rooms/bathroom1.jpg";
import room3 from "../assets/img/rooms/room2.jpg";
import room4 from "../assets/img/rooms/bathroom2.jpg";
import room5 from "../assets/img/rooms/room3.jpg";
import room6 from "../assets/img/rooms/bathroom3.jpg";
import room7 from "../assets/img/rooms/room4.jpg";
import room8 from "../assets/img/rooms/bathroom4.jpg";

const roomsImages = [room1, room2, room3, room4, room5, room6, room7, room8];

export default function Main() {
  const commonSpaceSliderData = [
    { title: "Sala", imgSrc: commonSpaces1, description: "" },
    {
      title: "Sala-gier",
      imgSrc: commonSpaces2,
      description: "",
    },
    {
      title: "Kawiarenka",
      imgSrc: commonSpaces3,
      description: "",
    },
    {
      title: "Sala",
      imgSrc: commonSpaces4,
      description: "",
    },
    {
      title: "Sala-gier",
      imgSrc: commonSpaces5,
      description: "",
    },
  ];
  const roomsSliderData = Array.from({ length: 8 }, (_, i) => ({
    title: `Room ${i + 1}`,
    title: "",
    imgSrc: roomsImages[i],
    description: `Krótki opis pokoju ${i + 1}`,
    description: "",
  }));

  const commonSpaceService = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 900,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const roomsService = {
    variableWidth: true,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 900,
    // autoplaySpeed: 0,
    slidesToShow: 3,
    draggable: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <main>
        <Bredcom />
        <CustomizedSlider
          slidesData={commonSpaceSliderData}
          service={commonSpaceService}
          paddingBottom={"pb-0"}
        >
          <h2>Nasza przestrzeń</h2>
          <p className="pb-1">
            Oferujemy Gościom szesnaście pokoi w których łącznie jest
            sześćdziesiąt dwa miejsca noclegowe w dwu budynkach. Pokoje są od
            dwu do pięcioosobowych. Mamy dużą przestrzeń wspólną. W pierwszym
            budynku: salę rekreacyjną z kawiarenką, jadalnię. W drugim obszerny
            hol i przestrzeń na poddaszu gdzie możliwe są różne aktywności.
          </p>
        </CustomizedSlider>
        <CustomizedSlider
          slidesData={roomsSliderData}
          paddingBottom={"pb-90"}
          withLightbox={true}
          withDescription={false}
          service={roomsService}
        >
          <h2>Nasze pokoje</h2>
          <p>
            Każdy nasz pokój ma własną łazienkę.
          </p>
        </CustomizedSlider>
      </main>
    </>
  );
}
